import { render, staticRenderFns } from "./AtopicDermatitis.vue?vue&type=template&id=83ad5860&lang=pug&"
import script from "./AtopicDermatitis.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitis.vue?vue&type=script&lang=js&"
import style0 from "./AtopicDermatitis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports